import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import EducatorArea from './EducatorArea';
import * as appCreators from '../../../../../actions/inboxv2';
import { operations as creators } from '../../../../../store/conversations';
import { isCreatingConversation } from '../../../../../../core/conversations/selectors';
import { fetchingUsers, user } from '../../../../../../core/selectors/users';
import * as classRoomSelectors from '../../../../../../core/selectors/classroom';
import { fetchUsers } from '../../../../../../core/actions/users';
import { canAccessEducatorArea } from '../../../../../../core/materials/permissions';
import { isPermissionDeniedError } from '../../../../../../core/materials/selectors';
import { selectors as materialsSelectors } from '../../../../../store/materials';
import { goToMaterials } from '../../../../../actions/navigation';

const isFetchingUsers = createSelector(
  fetchingUsers,
  classRoomSelectors.instructorUsers,
  (users, educatorsIds = []) =>
    educatorsIds?.reduce((acc, id) => acc || users[id], false)
);

const isChangingClassRoom = createSelector(
  classRoomSelectors.classRoom,
  (spaceMeta) => spaceMeta.isChangingClassRoom
);

const shouldDisplaySectionsLoader = createSelector(
  materialsSelectors.hasFetchedSections,
  materialsSelectors.isFetchingSections,
  isChangingClassRoom,
  isPermissionDeniedError,
  (hasFetched, isFetching, isChangingSpace, hasPermissionError) =>
    !hasPermissionError && ((!hasFetched && isFetching) || isChangingSpace)
);

const mapStateToProps = (state) => ({
  educatorsIds: classRoomSelectors.instructorUsers(state),
  educators: classRoomSelectors.instructorUsers(state)?.reduce((acc, id) => {
    const usr = user(state, id);
    return [...acc, ...(usr ? [usr] : [])];
  }, []),
  fetching: isFetchingUsers(state),
  spaceId: classRoomSelectors.currentClassRoomId(state),
  creating: isCreatingConversation(state),
  isReadOnlyUser: classRoomSelectors.accessingCurrentSpaceAsStaff(state),
  canAccessEducatorArea: canAccessEducatorArea(state),
  shouldDisplaySectionsLoader: shouldDisplaySectionsLoader(state),
});

const mapDispatchToProps = (dispatch) => ({
  createConversation: (spaceId) =>
    dispatch(
      creators.createConversation({
        spaceId,
        educatorOnly: true,
      })
    ),
  selectConversation: (conversationId, source) =>
    dispatch(appCreators.selectConversation(conversationId, source)),
  fetchUsers: (users) => dispatch(fetchUsers(users)),
  goToMaterials: (spaceId) => dispatch(goToMaterials(spaceId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EducatorArea);
